"use client";

const testimonials = [
  {
    quote:
      "Probably the most modern MacOS CI solution out there. The team is super responsive too.",
    role: "DevOps Engineer",
  },
  {
    quote:
      "Great service! Our iOS build times have halved since switching to GetMac.",
    role: "Senior iOS Developer",
  },
  {
    quote: "Awesome support team that helped us get set up quickly and easily.",
    role: "Engineering Manager",
  },
  {
    quote: "The cheapest Mac CI/CD solution we've found that actually works.",
    role: "Backend Developer",
  },
  {
    quote:
      "Crazy cheap and super fast compared to GitHub-hosted Mac runners. Price is unbeatable.",
    role: "CTO",
  },
  {
    quote:
      "We needed a reliable Mac CI solution and GetMac delivered beyond our expectations.",
    role: "Senior iOS Developer",
  },
  {
    quote: "Thanks to GetMac, our build times are now faster than ever!",
    role: "Senior iOS Developer",
  },
  {
    quote:
      "We needed a solution that could integrate with GitLab CI/CD and GetMac was perfect.",
    role: "Backend Developer",
  },
];

export function TestimonialsSection() {
  return (
    <section>
      <div className="max-w-5xl mx-auto px-4">
        <header className="text-center mb-8 sm:mb-12 md:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-4">
            Loved by developers worldwide.
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto">
            Want to be featured here?{" "}
            <a
              href="mailto:hello@getmac.io"
              className="underline underline-offset-4 font-medium text-primary hover:text-primary/80 transition-colors duration-300"
            >
              Send us your feedback!
            </a>
          </p>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 sm:gap-x-8 md:gap-x-12 lg:gap-x-16 gap-y-8 sm:gap-y-12 auto-rows-fr">
          {testimonials.map((testimonial, i) => (
            <div key={i} className="flex flex-col h-full group">
              <div className="flex-grow">
                <p className="text-base sm:text-lg text-foreground/90 leading-relaxed text-left sm:text-justify mb-6 sm:mb-8">
                  &ldquo;{testimonial.quote}&rdquo;
                </p>
              </div>

              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-1 h-6 sm:h-8 bg-primary/20 group-hover:bg-primary transition-colors duration-300" />
                <p className="text-xs sm:text-sm text-foreground/60 font-light tracking-wide group-hover:text-primary transition-colors duration-300">
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
